export default __webpack_public_path__ + "static/media/gc.61371038.png";